const theme = {
	BASE_FONT_FAMILY: "Menlo, monospace",
	BASE_FONT_SIZE: "11px",
	BASE_LINE_HEIGHT: "14px",

	BASE_BACKGROUND_COLOR: "white",
	BASE_COLOR: "black",

	OBJECT_NAME_COLOR: "rgb(136, 19, 145)",
	OBJECT_VALUE_NULL_COLOR: "rgb(128, 128, 128)",
	OBJECT_VALUE_UNDEFINED_COLOR: "rgb(128, 128, 128)",
	OBJECT_VALUE_REGEXP_COLOR: "rgb(196, 26, 22)",
	OBJECT_VALUE_STRING_COLOR: "rgb(196, 26, 22)",
	OBJECT_VALUE_SYMBOL_COLOR: "rgb(196, 26, 22)",
	OBJECT_VALUE_NUMBER_COLOR: "rgb(28, 0, 207)",
	OBJECT_VALUE_BOOLEAN_COLOR: "rgb(28, 0, 207)",
	OBJECT_VALUE_FUNCTION_KEYWORD_COLOR: "rgb(170, 13, 145)",

	HTML_TAG_COLOR: "rgb(168, 148, 166)",
	HTML_TAGNAME_COLOR: "rgb(136, 18, 128)",
	HTML_TAGNAME_TEXT_TRANSFORM: "lowercase",
	HTML_ATTRIBUTE_NAME_COLOR: "rgb(153, 69, 0)",
	HTML_ATTRIBUTE_VALUE_COLOR: "rgb(26, 26, 166)",
	HTML_COMMENT_COLOR: "rgb(35, 110, 37)",
	HTML_DOCTYPE_COLOR: "rgb(192, 192, 192)",

	ARROW_COLOR: "#6e6e6e",
	ARROW_MARGIN_RIGHT: 3,
	ARROW_FONT_SIZE: 12,

	TREENODE_FONT_FAMILY: "Menlo, monospace",
	TREENODE_FONT_SIZE: "11px",
	TREENODE_LINE_HEIGHT: "14px",
	TREENODE_PADDING_LEFT: 12,

	TABLE_BORDER_COLOR: "#aaa",
	TABLE_TH_BACKGROUND_COLOR: "#eee",
	TABLE_TH_HOVER_COLOR: "hsla(0, 0%, 90%, 1)",
	TABLE_SORT_ICON_COLOR: "#6e6e6e",
	TABLE_DATA_BACKGROUND_IMAGE:
		"linear-gradient(to bottom, white, white 50%, rgb(234, 243, 255) 50%, rgb(234, 243, 255))",
	TABLE_DATA_BACKGROUND_SIZE: "128px 32px",
};

export default theme;
